__webpack_require__.p = "/projects/chronic-kidney-disease/";